// src/pages/public/NotFound/NotFoundPage.jsx
import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import SEO from '../../../components/seo/SEO.jsx'
import Button from '../../../components/common/Button.jsx'

import './NotFoundPage.scss'

export default function NotFoundPage() {
    return (
        <>
            <SEO
                title="Page Not Found"
                description="The page you're looking for doesn't exist or has been moved."
                noindex={true}
            />

            <div className="not-found-page-root">
                {/* =========================
                    HERO SECTION
                   ========================= */}
                <section className="not-found-hero-section">
                    <div className="not-found-hero-container">
                        <motion.div
                            className="not-found-content"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                        >
                            {/* Illustration */}
                            <motion.div
                                className="not-found-illustration"
                                initial={{ scale: 0.8, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.6, delay: 0.2 }}
                            >
                                {/* <div className='illustration-circle'> */}
                                <div className="illustration-text">404</div>
                                {/* </div> */}
                            </motion.div>

                            {/* Content */}
                            <motion.h1
                                className="not-found-heading"
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.4 }}
                            >
                                PAGE NOT FOUND
                            </motion.h1>

                            <motion.p
                                className="not-found-subheading"
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.5 }}
                            >
                                Sorry, we couldn't find the page you're looking for. The page might have been moved,
                                deleted, or you may have entered an incorrect URL.
                            </motion.p>

                            {/* Primary Action Button */}
                            <motion.div
                                className="not-found-actions"
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: 0.6 }}
                            >
                                <Link to="/">
                                    <button className="not-found-button">
                                        Go Back Home
                                    </button>
                                </Link>
                            </motion.div>
                        </motion.div>
                    </div>
                </section >

                {/* =========================
                    QUICK LINKS SECTION
                   ========================= */}
                <section section className="not-found-links-section" >
                    <div className="not-found-links-container">
                        <motion.div
                            className="links-content"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.6, delay: 0.7 }}
                        >
                            <h3 className="links-heading">
                                Popular Pages
                            </h3>
                            <div className="links-grid">
                                <Link to="/services" className="link-item">
                                    <div className="link-border-glow" />
                                    <span className="link-text">Services</span>
                                </Link>
                                <Link to="/industries" className="link-item">
                                    <div className="link-border-glow" />
                                    <span className="link-text">Industries</span>
                                </Link>
                                <Link to="/case-studies" className="link-item">
                                    <div className="link-border-glow" />
                                    <span className="link-text">Case Studies</span>
                                </Link>
                                <Link to="/blogs" className="link-item">
                                    <div className="link-border-glow" />
                                    <span className="link-text">Blog</span>
                                </Link>
                                <Link to="/careers" className="link-item">
                                    <div className="link-border-glow" />
                                    <span className="link-text">Careers</span>
                                </Link>
                                <Link to="/about" className="link-item">
                                    <div className="link-border-glow" />
                                    <span className="link-text">About Us</span>
                                </Link>
                            </div>
                        </motion.div>
                    </div>
                </section >
            </div >
        </>
    )
}